<template>
	<div class="layout-grid-header">
		<layout-grid-category-picker v-if="hasCategories" @onCategoryChange="onCategoryChange" @onCategoriesChange="onCategoriesChange" @registerCategoryPicker="registerCategoryPicker" :create-if-missing="createIfMissing" :layout-type="layoutType" :org-id="orgId" />
		<div v-if="hasCategories" class="ui icon labeled button" data-tooltip="Create category" @click="createCategory"><i class="plus icon"></i>Category</div>
		<div v-if="hasCategories" class="ui icon button" :class="removeCategoryButtonsClass" data-tooltip="Remove category" @click="removeCategory"><i class="remove icon"></i></div>
		<div v-if="hasCategories" class="ui icon button" :class="dynamicCategoryButtonsClass" data-tooltip="Edit category name" @click="editCategory"><i class="edit icon"></i></div>
		<div class="ui labeled icon button" style="margin-left: 2em;" @click="createLayout" v-if="createLayoutFunction" :id="createLayoutButtonId"><i class="plus icon"></i>{{ layoutTypeDisplay }}</div>
		
		<div class="ui icon input layout-grid-search"><input type="search" placeholder="Search..." style="width: auto;" v-model="filter" @keyup.esc="cancelFilter"><i class="search icon"></i></div>
	</div>
</template>

<script>
import LayoutGridCategoryPicker from './LayoutGridCategoryPicker.vue';

export default {
	props: {
		createLayoutFunction: null,
		layoutType: null,
		layoutTypeDisplay: null,
		hasCategories: {
			type: Boolean,
			default: true
		},
		createIfMissing: {
			default: true
		},
		orgId: null
	},
	data: function() {
		return {
			layoutCategories: [],
			layoutCategory: null,
			filter: '',
			bookFormats: []
		};
	},
	computed: {
		currentBookFormats: function() {
			var allBookFormats = this.bookFormats;

			if(this.layoutCategory.bookFormatIds) {
				var bookFormats = [];
				this.layoutCategory.bookFormatIds.forEach(function(bookFormatId) {
					var bookFormat = allBookFormats.filter(function(bookFormat) {
						return bookFormat.formatId === bookFormatId;
					})[0];

					if(bookFormat) {
						bookFormats.push(bookFormat);
					}
				});

				return bookFormats;
			} else {
				return allBookFormats;
			}
		},
		removeCategoryButtonsClass: function() {
			var classObj = {};

			if(this.layoutCategories.length <= 1) {
				classObj.disabled = true;
			}

			return classObj;
		},
		dynamicCategoryButtonsClass: function() {
			var classObj = {};

			if(this.layoutCategories.length == 0) {
				classObj.disabled = true;
			}

			return classObj;
		},
		createLayoutButtonId: function() {
			return 'createLayoutButtonId-' + this.layoutTypeDisplay.replace(' ', '');
		}
	},
	watch: {
		filter: function() {
			var filter = this.filter;
			if(this.filter.length < 2) {
				filter = '';
			}

			$.setSingleTimeout.call(this, 'delayedUpdateFilter', function() {
				this.$emit('onFilter', filter);
			}, 100);
		}
	},
	methods: {
		getCategorySettings: function(currentCategory) {
			if(!currentCategory) {
				currentCategory = {};
			}

			if(typeof this.orgId === 'undefined' && this.layoutType != 'Flyer') {
				return [
					{
						id: 'name',
						type: 'text',
						description: 'Name',
						value: currentCategory.name
					},
					{
						id: 'bookFormatIds',
						type: 'dropdown',
						description: 'Show on these Book Formats',
						placeholder: 'Defaults to all',
						value: currentCategory.bookFormatIds ? currentCategory.bookFormatIds.join(',') : null,
						multiple: true,
						options: this.bookFormats,
						itemId: 'formatId'
					},
					{
						id: 'projectTypes',
						type: 'dropdown',
						description: 'Project Types',
						placeholder: 'Defaults to all',
						value: currentCategory.projectTypes ? currentCategory.projectTypes.join(',') : null,
						multiple: true,
						options: $.getSettingDefinitionFromSet($.projectSettings, 'projectType').options
					}
				];
			} else {
				return [
					{
						id: 'name',
						type: 'text',
						description: 'Name',
						value: currentCategory.name
					}
				];
			}
		},
		createCategory: function(event) {
			var button = event.target;

			var me = this;
			$.SettingsBuilderDialog(this.getCategorySettings(), {
				title: 'Create Category',
				onSettingsApplied: function(settings, changes) {
					settings.type = me.layoutType;
					if(typeof me.orgId === 'undefined') {
						if(settings.bookFormatIds) {
							settings.bookFormatIds = settings.bookFormatIds.split(',');
						}
					} else if($.currentLoadedSchool && $.currentLoadedSchool.bookFormat && $.currentLoadedSchool.bookFormat.formatId) {
						settings.bookFormatIds = [$.currentLoadedSchool.bookFormat.formatId];
						settings.orgId = me.orgId;
					}

					if(settings.projectTypes) {
						settings.projectTypes = settings.projectTypes.split(',');
					}

					$(button).removeClass('red').addClass('blue loading');
					$.ajax({
						url: 'ajax/createLayoutCategory.php',
						data: settings,
						type: 'POST',
						dataType: 'json',
						success: function(data) {
							var layoutCategory = data.category;
							me.categoryPicker.addCategory(layoutCategory);
							me.categoryPicker.setCategory(layoutCategory);
						},
						error: function(xhr) {
							$(button).removeClass('blue').addClass('red');
							if(xhr.responseText && xhr.responseText.indexOf('has already been taken') != -1) {
								$.Alert('Error', `The name "${settings.name}" is already taken`);
							} else {
								$.Alert('Error', 'Failed to insert new layout category');
							}
						},
						complete: function() {
							$(button).removeClass('loading');
						}
					});
				}
			});
		},
		removeCategory: function(event) {
			var button = $(event.target).closest('.icon.button');
			var layoutCategory = this.categoryPicker.getCurrentCategory();

			var me = this;
			$.ConfirmDelete('Delete Layout Category', 'Are you sure you want to delete ' + layoutCategory.name + '?', function() {
				$(button).addClass('loading');
				$.ajax({
					url: 'ajax/deleteLayoutCategory.php',
					data: {
						id: layoutCategory.id
					},
					dataType: 'json',
					type: 'POST',
					success: function(data) {
						me.categoryPicker.removeCategory(layoutCategory);
					},
					error: function() {
						$.Alert('Error', 'Failed to deletet layout category');
					},
					complete: function() {
						$(button).removeClass('loading');
					}
				});
			});
		},
		editCategory: function(event) {
			var button = $(event.target).closest('.icon.button');
			var currentCategory = this.categoryPicker.getCurrentCategory();

			var me = this;
			$.SettingsBuilderDialog(this.getCategorySettings(currentCategory), {
				title: 'Edit ' + currentCategory.name,
				onSettingsApplied: function(settings, changes) {
					settings.id = currentCategory.id;
					if(settings.bookFormatIds) {
						settings.bookFormatIds = settings.bookFormatIds.split(',');
					}
					if(settings.projectTypes) {
						settings.projectTypes = settings.projectTypes.split(',');
					}

					$(button).removeClass('red').addClass('blue loading');
					$.ajax({
						url: 'ajax/saveLayoutCategory.php',
						data: settings,
						type: 'POST',
						dataType: 'json',
						success: function() {
							currentCategory.name = settings.name;
							currentCategory.bookFormatIds = settings.bookFormatIds;
							currentCategory.projectTypes = settings.projectTypes;
							me.categoryPicker.editCategoryName(currentCategory, settings.name);
						},
						error: function(xhr) {
							$(button).removeClass('blue').addClass('red');
							if(xhr.responseText && xhr.responseText.indexOf('has already been taken') != -1) {
								$.Alert('Error', `The name "${settings.name}" is already taken`);
							} else {
								$.Alert('Error', 'Failed to edit layout category');
							}
						},
						complete: function() {
							$(button).removeClass('loading');
						}
					});
				}
			});
		},
		createLayout: function(event) {
			this.createLayoutFunction(event.target, this.layoutCategory, this);
		},
		onCategoryChange: function(layoutCategory) {
			this.layoutCategory = layoutCategory;
			this.$emit('onCategoryChange', layoutCategory);
		},
		onCategoriesChange: function(layoutCategories, bookFormats) {
			this.layoutCategories = layoutCategories;
			this.bookFormats = bookFormats;

			this.$emit('updateBookFormats', bookFormats);
		},
		registerCategoryPicker: function(categoryPicker) {
			this.categoryPicker = categoryPicker;
		},
		cancelFilter: function(event) {
			this.filter = '';
		}
	},
	components: {
		LayoutGridCategoryPicker
	}
};
</script>

<style scoped>
.layout-grid-header {
	display: flex;
	flex-grow: 0;
	margin-bottom: 1em;
	align-items: center;
}

.layout-grid-header .layout-grid-search {
	margin-left: auto;
}
</style>